import { render } from "./AuthHeader.vue?vue&type=template&id=4c891c10&scoped=true"
import script from "./AuthHeader.vue?vue&type=script&lang=js"
export * from "./AuthHeader.vue?vue&type=script&lang=js"

import "./AuthHeader.vue?vue&type=style&index=0&id=4c891c10&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c891c10"]])

export default __exports__